import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Contact = () => {

  const [letterClass, setLetterClass] = useState('text-animate');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const form = useRef()

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    if(!formSubmitted){
      emailjs
      .sendForm('service_stzwmpb', 'template_s5k2at4', form.current, '__EctLy0dQr9ggvRx')
      .then(
        () => {
          alert('Message successfully sent!')
          
          window.location.reload(false)
        },
        () => {
          alert('Failed to send the message, please try again later. Sorry!')
          
        }
      )

      setFormSubmitted(true);
      

    }
    
  }

  return (
    <>
      
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'M', 'e']}
              idx={15}
            />
          </h1>
          <p>
            If you have any requests or questions, feel free to contact me through the form below!
          </p>
          <div className="contact-form">
            
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="name" required />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND"  />


                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Darren Li, <br />
          Columbus, Indiana, 47201 <br />
          United States of America <br />
        </div>
        <div className="map-wrap">
          <MapContainer center={[39.2014, -85.911056]} zoom={4}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[39.2014, -85.911056]}>
              <Popup>Here's my hometown!</Popup>
            </Marker>
            <Marker position={[36.0014, -78.9382]}>
              <Popup>Here's where I go to school!</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />

    </>
  )
}

export default Contact
